import React from 'react'
import ModalWrapper from '../../common/Modal/ModalWrapper'
import Button from '../../common/Button'
import { useLocation } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const ConnectDataroomModal = ({ company }) => {
    const location = useLocation();
    const dataroom = [
        { id: 1, name: 'Google Drive', linkKey: 'gDriveURL' },
        { id: 2, name: 'Dropbox', linkKey: 'dropboxURL' },
        { id: 3, name: 'Sharepoint', linkKey: 'sharePointAuthURL' }
    ]

    const info = [
        'Dedicated Diligentsia Folder',
        'Syncs only when you command it',
        'We never access your other folders',
        'Alternative way to create Data Repository'
    ]

    return (
        <ModalWrapper
            modalType={"connectDataroom"}
            modalCardClasses='maw1200px'
            customStyle={{
                background: 'linear-gradient(180deg, rgba(245, 247, 255, 1) 0%, rgba(232, 236, 255, 1) 100%)',
                padding: '3rem 4rem',
            }}
            girlComponent={<div className='pa df fdc '>
                <img className='pa' src={require('../../../../images/connectDataroom/girlAI.png')} alt='girl' style={{ width: '200px', bottom: '-80px' }} />
                <img className='pa' src={require('../../../../images/connectDataroom/Group.svg')} alt='Group' style={{ width: '250px', top: '0', right: '-150px' }} />
            </div>}
        >
            <div>
                <h1 className='c15 fw500'>Connect data room</h1>
                <p className='c15'>Securely link your existing cloud provider to automatically backup and sync your Data Repository documents.</p>
            </div>

            <div className='dg gtcr1-sm gtcr3a-md gg1rem mt2rem'>
                {dataroom.map(room => {
                    let image = ''
                    if (room.name === 'Google Drive') image = require('../../../../images/connectDataroom/drive.svg')
                    else if (room.name === 'Dropbox') image = require('../../../../images/connectDataroom/dropbox.svg')
                    else if (room.name === 'Sharepoint') image = require('../../../../images/connectDataroom/sharepoint.svg')
                    return (
                        <div key={room.id} className='bg1 p1-5rem pb2rem br20px c15 cp df fdc aifs jcfs'>
                            {image && <img src={image} alt={room.name} style={{ width: '80px', height: '80px', objectFit: 'contain' }} />}
                            <h1 className='fw500 fs1-5rem tal w100 my1rem'>{room.name}</h1>
                            <Button
                                btnType='warningOutlined'
                                text={`Connect Now`}
                                customClassName='df aic jcsb'
                                style={{ padding: '8px 16px', width: '180px' }}
                                onClick={() => {
                                    // if (location.pathname.split('/')[1] === ROUTES.COMPANY_OLD.split('/')[1])
                                    //     window.localStorage.setItem('fromTempCompany', "true");
                                    window.location.href = `${company[room?.linkKey]}`
                                }}
                                icon={<img src={require('../../../../images/fractional/right-arrows1.svg')} alt={room.name} width={20} />}
                            />
                        </div>
                    )
                })}
            </div>

            <div
                className='bg1 p2rem br20px mt3rem df aic jcsb'
            >
                {
                    info.map((item, index) => (
                        <div key={index} className='df aic mr3rem w25'>
                            <img src={require('../../../../images/connectDataroom/check.svg')} alt='check' width={20} className='mr0-5rem' />
                            <span className='c15 fs10px fsi'>{item}</span>
                        </div>
                    ))
                }

            </div>
        </ModalWrapper>
    )
}

export default ConnectDataroomModal